export const NEW_REQUEST_FORM_HEADER_ID = 'request-resource-approval-header';
export const PROGRAM_REQUEST = 'Program';
export const RESOURCE_REQUEST = 'Resource';
export const REREQUEST = 'Rerequest';
export const REQUEST_FORM_PROGRAM_DRAWER_TEST_ID =
  'request-form-program-drawer';
export const REQUEST_FORM_RESOURCES_DRAWER_TEST_ID =
  'request-form-resources-drawer';
